import { api } from './client';
import { saveBlob } from '@/shared/utils/download';

export interface MigrationToken {
  id: string;
  organization_id: string;
  name: string;
  created_at: string;
  expires_at: string | null;
  revoked_at: string | null;
  last_used_at: string | null;
  source_config: string | null;
  token: string | null;  // Тільки при створенні
}

export interface MigrationTokenCreate {
  organization_id: string;
  name: string;
  expires_in_days?: number;
  source_config?: string | null;
}

export const migration = {
  listTokens: () =>
    api.get<MigrationToken[]>('/migration/tokens').then((r) => r.data),
  createToken: (p: MigrationTokenCreate) =>
    api.post<MigrationToken>('/migration/tokens', p).then((r) => r.data),
  revokeToken: (id: string) =>
    api.post(`/migration/tokens/${id}/revoke`).then(() => undefined),
};

/** ч.1436: з якої 1С переносять — за цим сервер обирає готову обробку. */
export type OneCPlatform = '8.2' | '8.3' | 'bas';
export type OneCForm = 'ordinary' | 'managed';
export type OneCConfig = 'utp12' | 'bp12' | 'bp20';
/** Варіанти, для яких обробка в розробці: на них можна записатись у перелік очікувачів. */
export type OneCWaitVariant = 'bas' | 'managed' | 'bp20';
export interface OneCChoice { platform: OneCPlatform; form: OneCForm; config: OneCConfig }

export type OneCProcessing =
  | { available: true; file_name: string; size: number; updated_at: string }
  | { available: false; reason: string };

export const oneCProcessing = {
  info: (c: OneCChoice) =>
    api.get<OneCProcessing>('/migration/processing', { params: c }).then((r) => r.data),
  download: async (c: OneCChoice, fileName: string) => {
    const r = await api.get<Blob>('/migration/processing/download', { params: c, responseType: 'blob' });
    saveBlob(r.data, fileName);
  },
  /** ч.1436: на що користувач уже чекає і запис у перелік очікувачів. */
  waiting: () =>
    api.get<{ variants: OneCWaitVariant[] }>('/migration/processing/waitlist').then((r) => r.data.variants),
  notifyMe: (variant: OneCWaitVariant) =>
    api.post<{ variant: OneCWaitVariant; created: boolean }>('/migration/processing/waitlist', { variant })
      .then((r) => r.data),
};
